module.exports = __webpack_public_path__ + "static/media/github.0ff1a6f0.svg";